import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Nav: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';
  const isServices = location.pathname === '/services';
  const isHire = location.pathname === '/hire-developers';
  const isContact = location.pathname === '/contact';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    if (isHome) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <>
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="container">
          <div className="nav-inner">
            <Link to="/" className="nav-logo">
              <img src="/slatewing-logo.png" alt="Slatewing Technologies" className="nav-logo-img" />
            </Link>

            <div className="nav-links">
              <Link to="/services" className={`nav-link${isServices ? ' nav-link-active' : ''}`}>
                Services
              </Link>
              <Link to="/hire-developers" className={`nav-link${isHire ? ' nav-link-active' : ''}`}>
                Hire Developers
              </Link>
              <button className="nav-link nav-scroll-btn" onClick={() => scrollTo('about')}>
                About
              </button>
              <button className="nav-link nav-scroll-btn" onClick={() => scrollTo('process')}>
                How We Work
              </button>
              <Link to="/contact" className={`btn btn-primary nav-cta${isContact ? ' nav-cta-active' : ''}`}>
                Get In Touch
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
            </div>

            <button className="nav-toggle" onClick={() => setMenuOpen(v => !v)} aria-label="Toggle menu">
              {menuOpen
                ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
                : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 12h18M3 6h18M3 18h18" /></svg>
              }
            </button>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/services" className="mobile-link">Services</Link>
        <Link to="/hire-developers" className="mobile-link">Hire Developers</Link>
        <button className="mobile-link nav-scroll-btn" style={{ textAlign: 'left', width: '100%' }} onClick={() => scrollTo('about')}>About</button>
        <button className="mobile-link nav-scroll-btn" style={{ textAlign: 'left', width: '100%' }} onClick={() => scrollTo('process')}>How We Work</button>
        <Link to="/contact" className="btn btn-primary mobile-cta">Get In Touch</Link>
      </div>
    </>
  );
};

export default Nav;
